// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2355":"509d9914","4706":"6d30e91d"}[chunkId] + ".chunk.css";
};